import { flatten } from "lodash";
import { State } from "./types";

const getCellsToPersist = (gridState: State.Grid) =>
  flatten(gridState.lines.map((line) => line.filter((cell) => Boolean(cell.furniture))));

const gridStateToPayload = (gridState: State.Grid, gridId: number, preserveIds = true) => ({
  id: gridId,
  shopGridCells: getCellsToPersist(gridState).map((cell) => ({
    id: (preserveIds && cell.id) || null,
    yAxis: cell.yAxis,
    xAxis: cell.xAxis,
    shopFurniture: cell.furniture?.id || null,
    shelvesCount: cell.shelvesCount,
    isHighlight: cell.isHighlight,
    shopGridCellSections: cell.sections
      .map((section, sectionIndex) => ({
        id: (preserveIds && section.id) || null,
        sectionIndex,
        shopGridCellSectionInventories: section.inventories
          .map((inventory, inventoryIndex) => ({
            id: (preserveIds && inventory.id) || null,
            inventoryIndex,
            subFamily: inventory.subFamily?.id || null,
            quantity: inventory.quantity,
          }))
          .filter((shopGridCellSectionInventory) => shopGridCellSectionInventory.subFamily),
      }))
      .filter((shopGridCellSection) => shopGridCellSection.shopGridCellSectionInventories.length > 0),
  })),
});

export default gridStateToPayload;
